import { render } from "./MoreLocations.vue?vue&type=template&id=54ddf438"
import script from "./MoreLocations.vue?vue&type=script&lang=js"
export * from "./MoreLocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__